import { NsPanel } from 'components/common/ns-panel/NsPanel';

import type { ScreenParts } from 'components/app/routes/app-routes-revamp';

export const OrderCompleteTemplate = (props: ScreenParts) => {
  const { Content, Header } = props;

  return (
    <>
      <NsPanel decoration="cyan-light">{Header && <Header />}</NsPanel>
      {Content && <Content />}
    </>
  );
};

export default OrderCompleteTemplate;
